import {isStatisticCookieAccepted} from "@/helpers"
import {DevLog} from "@/helpers/consoleHelpers"
import {useGtm} from "@gtm-support/vue-gtm"


export default {
    logEvent(label: string, value: unknown, action = 'click', category = window.location.href, event = 'event') {
        const gtm = useGtm()

        if (!navigator.cookieEnabled || !isStatisticCookieAccepted()) {
            DevLog.log("Analytics disabled, event won't be logged")
            gtm?.enable(false);
            return
        }
        gtm?.enable(true);
        gtm?.trackEvent({
            event: event,
            category: category,
            action: action,
            label: label,
            value: value,
        })
    }
}